import { useState, useEffect, useCallback } from 'react';
import { simStudioApi } from '../api/simStudioApi';
import type { DemoSchool } from '../api/simStudioApi';

export function useSimSchools() {
  const [schools, setSchools] = useState<DemoSchool[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await simStudioApi.getDemoSchools();
      setSchools(data);
    } catch (e: any) {
      setError(e?.message ?? 'Erro ao carregar escolas');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  return { schools, loading, error, reload };
}
